/**
 * Extrait le token d'un lien d'invitation `/invite/:token` (migration 0259).
 * Contrairement au handoff SSO (`parseJoinUrl`, token dans le FRAGMENT, à
 * usage unique et jamais destiné à être partagé), ce lien EST fait pour être
 * partagé et réutilisé — le token vit dans le CHEMIN, comme les autres liens
 * d'invitation du repo (`tutor_invite_links` → `/rejoindre/$token`).
 */
export function parseInviteUrl(pathname: string): string | null {
  const match = pathname.match(/\/invite\/([^/]+)/);
  return match ? match[1]! : null;
}
